export enum Borders {
  NONE = 'none',
  DASHED = 'dashed',
  TRANSPARENT = 'transparent',
  '1PX' = '1px',
  '2PX' = '2px',
  '3PX' = '3px',
  '4PX' = '4px',
  '6PX' = '6px',
}
